import { Form } from "../data/data";

export type FormState = Record<string, string | number | boolean>;

export function buildInitialState(schema: Form): FormState {
    const s: FormState = {};
    schema.steps.forEach((step) =>
        step.fields.forEach((f) => {
            s[f.name] = f.defaultValue ?? "";
        }),
    );
    return s;
}
